<template>
  <div class="row">&nbsp;</div>
  <div v-if="this.user.role_name==='systemadmin' || this.user.role_name==='system' || this.user.role_name==='photo-admin'">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="row">
            <!-- <WelcomeCard /> -->
            <div class="col-xxl-12">
              <div class="row widget-grid">
                <div class="card profile-box">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body">
                        <div class="greeting-user">
                          <h4 class="f-w-600 mb-0">
                            <vue-feather
                              type="server"
                              size="25"
                            ></vue-feather>
                            Coupon
                          </h4>
                          <p>&nbsp;</p>
                          <p>&nbsp;</p>
                        </div>
                      </div>
                    </div>
                    <div class="cartoon">
                      <img
                        class="img-fluid"
                        src="@/assets/images/dashboard/cartoon.svg"
                        alt="vector women with leptop"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12" v-if="this.page_permission === 'Y'">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <form @submit.prevent="create_event" class="needs-validation">
                  <div class="col-sm-12">
                  <b>Coupon system: </b>&nbsp;&nbsp;
                <div class="form-check form-check-inline">
                   <input class="form-check-input" @change.prevent="update_event_coupon" v-model="is_enable_coupon_system" checked required type="radio"
                    name="inlineRadioOptions" id="inlineRadio1" value="Y">
                  <label class="form-check-label" for="inlineRadio1">
                    Enable
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" @change.prevent="update_event_coupon" v-model="is_enable_coupon_system" type="radio" required name="inlineRadioOptions"
                    id="inlineRadio2" value="N">
                  <label class="form-check-label" for="inlineRadio2">
                    Disable
                  </label>
                </div>
                </div>
              </form>
            </div>
          </div>

          
          </div>

        <div class="card coupon-monitor-card" v-if="this.is_enable_coupon_system === 'Y'">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h5 class="mb-1">Coupon Monitor</h5>
                    <small class="text-muted coupon-summary-line">
                      ทั้งหมด {{ conpon_obj.length }} รายการ
                      <button
                        type="button"
                        class="export-mini-btn"
                        :disabled="conpon_obj.length === 0"
                        @click="exportToExcel('all')"
                      >
                        <vue-feather type="download" size="11"></vue-feather>
                      </button>
                      |
                      ใช้ไปแล้ว {{ conpon_obj.filter(item => Number(item.unit) <= 0).length }} รายการ
                      <button
                        type="button"
                        class="export-mini-btn"
                        :disabled="conpon_obj.filter(item => Number(item.unit) <= 0).length === 0"
                        @click="exportToExcel('used')"
                      >
                        <vue-feather type="download" size="11"></vue-feather>
                      </button>
                      |
                      คงเหลือ {{ conpon_obj.filter(item => Number(item.unit) >= 1).length }} รายการ
                      <button
                        type="button"
                        class="export-mini-btn"
                        :disabled="conpon_obj.filter(item => Number(item.unit) >= 1).length === 0"
                        @click="exportToExcel('unused')"
                      >
                        <vue-feather type="download" size="11"></vue-feather>
                      </button>
                    </small>
                  </div>
                  <div class="coupon-header-actions">
                    <button
                      type="button"
                      class="btn btn-sm coupon-excel-button"
                      :disabled="conpon_obj.length === 0"
                      title="Export Excel"
                      aria-label="Export all coupon details to Excel"
                      @click="exportToExcel('all')"
                    >
                      <vue-feather type="file-text" size="14"></vue-feather>
                      Export Excel
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm coupon-refresh-button"
                      :disabled="is_coupon_searching"
                      title="Refresh"
                      aria-label="Refresh Coupon Monitor"
                      @click="refreshCoupons"
                    >
                      <vue-feather type="refresh-cw" size="14"></vue-feather>
                      Refresh
                    </button>
                    <div class="form-check form-switch m-0">
                      <input
                        id="show-coupon-vouchers"
                        v-model="show_coupon_vouchers"
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                      >
                      <label class="form-check-label" for="show-coupon-vouchers">
                        แสดง Coupon Vouchers
                      </label>
                    </div>
                  </div>
                </div>
                <section class="coupon-overview mb-3" aria-label="สรุปการใช้งานคูปอง">
                  <div class="coupon-chart-wrap">
                    <apexchart
                      type="donut"
                      height="190"
                      :options="coupon_chart_options"
                      :series="coupon_chart_series"
                    ></apexchart>
                  </div>
                  <div class="coupon-metrics">
                    <div class="coupon-metric coupon-metric-total">
                      <span class="coupon-metric-label">คูปองทั้งหมด</span>
                      <strong>{{ coupon_stats.total }}</strong>
                      <span>รายการ</span>
                      <div v-if="coupon_amount_summary_map.total.length > 0" class="coupon-amount-breakdown coupon-amount-breakdown-total">
                        <div class="coupon-amount-breakdown-title">แยกตามยอด</div>
                        <div class="coupon-amount-breakdown-list">
                          <span
                            v-for="item in coupon_amount_summary_map.total"
                            :key="`total-${item.amount}`"
                            class="coupon-amount-breakdown-item"
                          >
                            {{ formatCurrency(item.amount) }} ({{ item.count }})
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="coupon-metric coupon-metric-used">
                      <span class="coupon-metric-label">ใช้งานแล้ว</span>
                      <strong>{{ coupon_stats.used }}</strong>
                      <span>รายการ</span>
                      <div v-if="coupon_amount_summary_map.used.length > 0" class="coupon-amount-breakdown coupon-amount-breakdown-used">
                        <div class="coupon-amount-breakdown-title">แยกตามยอด</div>
                        <div class="coupon-amount-breakdown-list">
                          <span
                            v-for="item in coupon_amount_summary_map.used"
                            :key="`used-${item.amount}`"
                            class="coupon-amount-breakdown-item"
                          >
                            {{ formatCurrency(item.amount) }} ({{ item.count }})
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="coupon-metric coupon-metric-remaining">
                      <span class="coupon-metric-label">คงเหลือ</span>
                      <strong>{{ coupon_stats.remaining }}</strong>
                      <span>รายการ</span>
                      <div v-if="coupon_amount_summary_map.remaining.length > 0" class="coupon-amount-breakdown coupon-amount-breakdown-remaining">
                        <div class="coupon-amount-breakdown-title">แยกตามยอด</div>
                        <div class="coupon-amount-breakdown-list">
                          <span
                            v-for="item in coupon_amount_summary_map.remaining"
                            :key="`remaining-${item.amount}`"
                            class="coupon-amount-breakdown-item"
                          >
                            {{ formatCurrency(item.amount) }} ({{ item.count }})
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section class="coupon-sales-report mb-3" aria-label="รายงานยอดขาย Coupon">
                  <div class="coupon-sales-heading">
                    <vue-feather type="bar-chart-2" size="16"></vue-feather>
                    <span>รายงานยอดขาย Coupon</span>
                  </div>
                  <div class="coupon-sales-metrics">
                    <div class="coupon-sales-item">
                      <span>ยอดขายรวมภาษีมูลค่าเพิ่ม</span>
                      <strong>{{ formatCurrency(coupon_sales_summary.total_including_vat) }}</strong>
                    </div>
                    <div class="coupon-sales-item">
                      <span>ยอดขายหลังหักภาษีมูลค่าเพิ่ม</span>
                      <strong>{{ formatCurrency(coupon_sales_summary.total_excluding_vat) }}</strong>
                    </div>
                    <div class="coupon-sales-item coupon-sales-item-vat">
                      <span>ภาษีมูลค่าเพิ่ม</span>
                      <strong>{{ formatCurrency(coupon_sales_summary.vat_amount) }}</strong>
                    </div>
                    <div class="coupon-sales-item coupon-sales-item-net">
                      <span>ยอดขายหลังหักค่าธรรมเนียมการชำระเงิน (5%)</span>
                      <strong>{{ formatCurrency(coupon_sales_summary.total_after_payment_fee) }}</strong>
                    </div>
                  </div>
                </section>
                <form class="coupon-search-bar mb-3" @submit.prevent="searchCoupons">
                  <select
                    v-model="coupon_search_type"
                    class="form-select form-select-sm coupon-search-type"
                    aria-label="ประเภทการค้นหา Coupon"
                  >
                    <option value="mobile">หมายเลขโทรศัพท์</option> 
                    <option value="payment_ref">เลขท้ายสลิปชำระเงิน (payment_ref)</option>
                    <option value="code">Coupon Code</option>
                    <option value="name">ชื่อ</option>
                    <option value="email">อีเมล</option>
                    
                  </select>
                  <input
                    v-model.trim="coupon_search_value"
                    type="search"
                    class="form-control form-control-sm coupon-search-input"
                    minlength="4"
                    placeholder="ค้นหาอย่างน้อย 4 ตัวอักษร"
                    aria-label="คำค้นหา Coupon"
                  >
                  <button
                    type="submit"
                    class="btn btn-sm coupon-search-button coupon-search-submit"
                    :disabled="coupon_search_value.length < 4 || is_coupon_searching"
                    title="ค้นหา"
                  >
                    <vue-feather type="search" size="14"></vue-feather>
                    ค้นหา
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm coupon-search-button"
                    :disabled="is_coupon_searching"
                    title="ล้างการค้นหา"
                    @click="clearCouponSearch"
                  >
                    <vue-feather type="x" size="14"></vue-feather>
                    ล้าง
                  </button>
                </form>
                <div class="coupon-filter-tags mb-3">
                  <button
                    type="button"
                    class="coupon-filter-tag"
                    :class="{ active: coupon_filter === 'all' }"
                    @click="coupon_filter = 'all'"
                  >
                    ทั้งหมด ({{ coupon_filter_counts.all }})
                  </button>
                  <button
                    type="button"
                    class="coupon-filter-tag"
                    :class="{ active: coupon_filter === 'used' }"
                    @click="coupon_filter = 'used'"
                  >
                    ใช้แล้ว ({{ coupon_filter_counts.used }})
                  </button>
                  <button
                    type="button"
                    class="coupon-filter-tag"
                    :class="{ active: coupon_filter === 'unused' }"
                    @click="coupon_filter = 'unused'"
                  >
                    ยังไม่ได้ใช้ ({{ coupon_filter_counts.unused }})
                  </button>
                  <button
                    type="button"
                    class="coupon-filter-tag"
                    :class="{ active: coupon_filter === 'pending_payment' }"
                    @click="coupon_filter = 'pending_payment'"
                  >
                    รอชำระ ({{ coupon_filter_counts.pending_payment }})
                  </button>
                </div>
                <div v-if="coupon_amount_filter_options.length > 0" class="coupon-amount-filter-tags mb-3">
                  <button
                    type="button"
                    class="coupon-filter-tag coupon-amount-filter-tag"
                    :class="{ active: coupon_amount_filter === 'all' }"
                    @click="coupon_amount_filter = 'all'"
                  >
                    ทุกยอด ({{ statusFilteredCoupons.length }})
                  </button>
                  <button
                    v-for="amount in coupon_amount_filter_options"
                    :key="amount"
                    type="button"
                    class="coupon-filter-tag coupon-amount-filter-tag"
                    :class="{ active: coupon_amount_filter === amount }"
                    @click="coupon_amount_filter = amount"
                  >
                    {{ formatCurrency(amount) }} ({{ coupon_amount_filter_counts[String(amount)] || 0 }})
                  </button>
                </div>
                <nav
                  v-if="coupon_total_pages > 1"
                  class="coupon-pagination mb-2"
                  aria-label="Coupon pagination top"
                >
                  <button
                    type="button"
                    class="coupon-page-button"
                    :disabled="coupon_page === 1"
                    title="หน้าก่อนหน้า"
                    aria-label="หน้าก่อนหน้า"
                    @click="coupon_page--"
                  >
                    <vue-feather type="chevron-left" size="13"></vue-feather>
                  </button>
                  <span class="coupon-page-status">{{ coupon_page }} / {{ coupon_total_pages }}</span>
                  <button
                    type="button"
                    class="coupon-page-button"
                    :disabled="coupon_page === coupon_total_pages"
                    title="หน้าถัดไป"
                    aria-label="หน้าถัดไป"
                    @click="coupon_page++"
                  >
                    <vue-feather type="chevron-right" size="13"></vue-feather>
                  </button>
                </nav>
            <div class="table-responsive-sm currency-table">
              <table class="table">
                <thead>
                  <tr>
                    <th class="f-light" style="text-align: center">No.</th>
                    <th class="f-light" style="text-align: center">Code</th>
                    <th class="f-light" style="text-align: center">Type</th>
                    <th class="f-light" style="text-align: right">Amount</th>
                    <th class="f-light" style="text-align: center">Discount(%)</th>
                    <th class="f-light" style="text-align: center">Unit</th>
                    <th class="f-light" style="text-align: center">Order</th>
                    <th class="f-light" style="text-align: center">Name</th>
                    <th class="f-light" style="text-align: center">Mobile</th>
                    <th class="f-light" style="text-align: center">Email</th>
                    <th class="f-light" style="text-align: center">Payment Ref</th>
                    <th class="f-light" style="text-align: center">Payment Date</th>
                    <th class="f-light" style="text-align: center">Photo order</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading === 'Y' &&  this.conpon_obj.length === 0" >
                  <tr>
                    <td colspan="13">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 30px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody v-if="paginatedCoupons.length !== 0">
                  <tr v-for="(item, index) in paginatedCoupons"
                      :key="item.id"
                      :class="{ 'table-danger': coupon_filter !== 'pending_payment' && Number(item.unit) <= 0 }">
                    <td style="text-align: center">
                      {{ ((coupon_page - 1) * coupon_page_size) + index + 1 }}
                    </td>
                    <td style="text-align: center">{{ item.code || '-' }}</td>
                    <td style="text-align: center">{{ item.type ?? '-' }}</td>
                    <td style="text-align: right">{{ formatCurrency(item.amount) }}</td>
                    <td style="text-align: center">{{ item.discount || '-' }}</td>
                    <td style="text-align: center">
                      <span
                        class="coupon-unit-status"
                        :class="coupon_filter === 'pending_payment' ? 'coupon-unit-pending' : Number(item.unit) >= 1 ? 'coupon-unit-unused' : 'coupon-unit-used'"
                      >
                        {{ coupon_filter === 'pending_payment' ? 'รอชำระ' : Number(item.unit) >= 1 ? 'ยังไม่ได้ใช้' : 'ใช้แล้ว' }}
                      </span>
                    </td>
                    <td style="text-align: center">
                      <a
                        v-if="item.order_uuid"
                        :href="websiteUrl + '/coupon/' + item.order_uuid"
                        class="text-decoration-underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Link Order
                      </a>
                      <span v-else>-</span>
                    </td>
                    <td style="text-align: center">{{ item.name || '-' }}</td>
                    <td style="text-align: center">{{ item.mobile || '-' }}</td>
                    <td style="text-align: center">{{ item.email || '-' }}</td>
                    <td style="text-align: center">{{ item.payment_ref || '-' }}</td>
                    <td style="text-align: center">{{ item.payment_date || '-' }}</td>
                    <td style="text-align: center">
                      <a
                        v-if="item.order_image_uuid"
                        :href="websiteUrl + '/d/' + item.order_image_uuid"
                        class="text-decoration-underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Link photo
                      </a>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
                <nav
                  v-if="coupon_total_pages > 1"
                  class="coupon-pagination mt-2"
                  aria-label="Coupon pagination bottom"
                >
                  <button
                    type="button"
                    class="coupon-page-button"
                    :disabled="coupon_page === 1"
                    title="หน้าก่อนหน้า"
                    aria-label="หน้าก่อนหน้า"
                    @click="coupon_page--"
                  >
                    <vue-feather type="chevron-left" size="13"></vue-feather>
                  </button>
                  <span class="coupon-page-status">{{ coupon_page }} / {{ coupon_total_pages }}</span>
                  <button
                    type="button"
                    class="coupon-page-button"
                    :disabled="coupon_page === coupon_total_pages"
                    title="หน้าถัดไป"
                    aria-label="หน้าถัดไป"
                    @click="coupon_page++"
                  >
                    <vue-feather type="chevron-right" size="13"></vue-feather>
                  </button>
                </nav>
              </div>
              <template v-if="show_coupon_vouchers">
                <div class="col-sm-12"><br>
                </div>
                <div class="col-sm-12">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h5 class="mb-0">Coupon Vouchers</h5>
                  <div class="d-flex gap-2">
                    <button 
                      v-if="conpon_obj.filter(item => Number(item.unit) >= 1).length > 0"
                      id="export-pdf-btn"
                      @click="exportToPDF" 
                      class="btn btn-success btn-sm"
                    >
                      <vue-feather type="download" size="14"></vue-feather>
                      Export PDF for Print
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div v-for="item in filteredVoucherCoupons" :key="item.id"  class="col-md-3 col-lg-3 mb-3">
                    <div class="voucher-card" :ref="`voucher-${item.id}`">
                      <div class="voucher-header">
                        <div class="voucher-logo-bg">
                          <img src="../../assets/images/running/running-logo-s.png" alt="Logo" class="logo-img-bg">
                        </div>
                        <div class="voucher-discount">{{ item.discount }}% OFF</div>
                        <div class="voucher-type">{{ item.description_en }}</div>
                      </div>
                      <div class="voucher-body">
                        <div class="voucher-code">{{ item.code }}</div>
                        <div class="voucher-remaining">{{ item.unit }} remaining</div>
                      </div>
                      <div class="voucher-footer">
                        <div class="facebook-follow">
                          <vue-feather type="facebook" size="14"></vue-feather>
                          Follow us Facebook: {{ systemFacebookName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </template>
            </div>
          </div>

        </div>

        <div
          class="card"
          v-if="this.is_enable_coupon_system === 'Y' && (this.user.role_name === 'systemadmin' || this.user.role_name === 'system')"
        >
          <div class="card-body">
            <div class="row">
              <form @submit.prevent="generate_coupon" class="needs-validation">
                <div class="col-sm-12">
                  <b>Generate Coupon </b>
                  <hr>
                  <div class="col-sm-12 col-lg-6">
                    <div class="input-group mb-3">
                      <label class="input-group-text mb-0" for="coupon-type">Coupon type</label>
                      <select class="form-select" required v-model="coupon_type" id="coupon-type">
                        <option value="BOTH">BOTH</option>
                        <option value="IMAGE">IMAGE</option>
                        <option value="VIDEO">VIDEO</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6">
                    <div class="input-group mb-3 ">
                      <span class="input-group-text" id="basic-addon1">Coupon Unit</span>
                      <input type="number" class="form-control" min="0" max="1000" v-model="coupon_discount_unit" placeholder="10" required>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6">
                    <div class="input-group mb-3 ">
                      <span class="input-group-text" id="basic-addon2">Coupon discount percent(%)</span>
                      <input type="text" class="form-control" minlength="5" maxlength="5" v-model="coupon_discount_percent" placeholder="37.4" required>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6">
                    <div class="input-group mb-3">
                      <span class="input-group-text" id="basic-addon3">Discount type</span>
                      <select disabled class="form-select" required v-model="coupon_discount_type" id="floatingSelect">
                        <option value="PERCENTAGE">PERCENTAGE</option>
                        <option value="FIXPRICE">FIXPRICE</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6">
                    <div class="input-group mb-3">
                      <span class="input-group-text" id="basic-addon4">Discount prefix(if any)</span>
                      <input type="text" class="form-control" minlength="3" maxlength="3" v-model="coupon_discount_prefix" placeholder="spi">
                    </div>
                  </div>
                  <div class="row">
                    <div class="d-flex justify-content-center">
                      <button type="submit" style="cursor: pointer" class="btn btn-primary btn-lg col-6">Generate coupon</button>&nbsp;
                      <button type="reset" @click.prevent="clear" style="cursor: pointer" class="btn btn-primary btn-lg">Clear</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
         </div>
        </div>
        
         <div v-if="this.page_permission === 'N'">
          <div class="d-flex justify-content-center">this page is not authorized</div>
        </div>

      </div>
    </div>
  </div>
  <div v-if="this.user.role_name === 'photographer'">
    <div class="d-flex justify-content-center">this page is not authorized</div>
  </div>
</template>
<style scoped>
.red-row {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}

.coupon-unit-status {
  font-weight: 600;
}

.coupon-unit-unused {
  color: #198754 !important;
}

.coupon-unit-used {
  color: #dc3545 !important;
}

.coupon-unit-pending {
  color: #b54708 !important;
}

.coupon-monitor-card {
  font-size: 12px;
}

.coupon-monitor-card h5 {
  font-size: 16px;
}

.coupon-monitor-card .form-control,
.coupon-monitor-card .form-select,
.coupon-monitor-card .btn,
.coupon-monitor-card .form-check-label {
  font-size: 11px;
}

.coupon-monitor-card .table {
  font-size: 11px;
}

.coupon-monitor-card .table th,
.coupon-monitor-card .table td {
  padding: 6px 5px;
}

.voucher-card {
  background: linear-gradient(145deg, #ff0000 00%, #ffffff 70%);
  border-radius: 15px;
  padding: 20px;
  color: rgb(0, 0, 0);
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.voucher-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.voucher-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transform: translate(30px, -30px);
}

.voucher-header {
  text-align: center;
  margin-bottom: 15px;
  position: relative;
}

.voucher-logo-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.logo-img-bg {
  width: 80px;
  height: 80px;
  object-fit: contain;
  opacity: 0.2;
}

.voucher-discount {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  position: relative;
  z-index: 2;
}

.voucher-type {
  font-size: 12px;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.voucher-body {
  text-align: center;
  margin-bottom: 15px;
}

.voucher-code {
  background: rgba(255, 255, 255, 0.2);
  padding: 10px 15px;
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 8px;
  border: 2px dashed rgba(255, 255, 255, 0.5);
}

.voucher-remaining {
  font-size: 12px;
  opacity: 0.8;
}

.voucher-footer {
  text-align: center;
}

.facebook-follow {
  font-size: 12px;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.coupon-filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.coupon-amount-filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #dbe7f7;
  background: #f7faff;
}

.coupon-amount-filter-tag {
  border-radius: 4px;
}

.coupon-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.coupon-refresh-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-color: #b6d4fe;
  background: #eef4ff;
  color: #0d6efd;
}

.coupon-excel-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-color: #a3cfbb;
  background: #eaf7ef;
  color: #198754;
}

.coupon-excel-button:hover:not(:disabled),
.coupon-excel-button:focus:not(:disabled) {
  border-color: #75b798;
  background: #d1e7dd;
  color: #146c43;
}

.coupon-excel-button:disabled {
  border-color: #d8efe2;
  background: #f4fbf7;
  color: #9ac7ae;
}

.coupon-refresh-button:hover:not(:disabled),
.coupon-refresh-button:focus:not(:disabled) {
  border-color: #86b7fe;
  background: #dbeafe;
  color: #0a58ca;
}

.coupon-refresh-button:disabled {
  border-color: #dbe7f7;
  background: #f5f8fc;
  color: #9dbce8;
}

.coupon-filter-tag {
  border: 1px solid #d0d5dd;
  background: #ffffff;
  color: #344054;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  transition: all 0.2s ease;
}

.coupon-filter-tag:hover {
  border-color: #0d6efd;
  color: #0d6efd;
}

.coupon-filter-tag.active {
  background: #0d6efd;
  border-color: #0d6efd;
  color: #ffffff;
}

.coupon-summary-line {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.coupon-overview {
  display: grid;
  grid-template-columns: minmax(220px, 320px) minmax(0, 1fr);
  align-items: center;
  gap: 24px;
  padding: 14px 18px;
  border: 1px solid #dbe7f7;
  background: #f7faff;
}

.coupon-chart-wrap {
  min-width: 0;
}

.coupon-chart-wrap :deep(.apexcharts-text),
.coupon-chart-wrap :deep(.apexcharts-legend-text) {
  font-family: Kanit, sans-serif !important;
}

.coupon-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(110px, 1fr));
  gap: 12px;
}

.coupon-metric {
  min-height: 96px;
  padding: 14px;
  border-left: 4px solid #7aa7e8;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.coupon-metric-total {
  border-left-color: #6c757d;
}

.coupon-metric-used {
  border-left-color: #f59e0b;
}

.coupon-metric-remaining {
  border-left-color: #0d6efd;
}

.coupon-metric-label {
  color: #475467;
  font-size: 11px;
  font-weight: 600;
}

.coupon-metric strong {
  color: #101828;
  font-size: 24px;
  line-height: 1.2;
}

.coupon-metric > span:last-child {
  color: #667085;
  font-size: 11px;
}

.coupon-amount-breakdown {
  margin-top: 10px;
  padding-top: 9px;
  border-top: 1px solid #e4e7ec;
}

.coupon-amount-breakdown-total {
  color: #475467;
}

.coupon-amount-breakdown-used {
  color: #b54708;
}

.coupon-amount-breakdown-remaining {
  color: #146c43;
}

.coupon-amount-breakdown-title {
  margin-bottom: 6px;
  color: #344054;
  font-size: 10px;
  font-weight: 600;
}

.coupon-amount-breakdown-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.coupon-amount-breakdown-item {
  border: 1px solid #a3cfbb;
  border-radius: 4px;
  background: #ffffff;
  color: #344054;
  padding: 4px 7px;
  font-size: 10px;
  font-weight: 600;
}

.coupon-sales-report {
  padding: 14px 18px;
  border: 1px solid #dbe7f7;
  background: #ffffff;
}

.coupon-sales-heading {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 10px;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}

.coupon-sales-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.coupon-sales-item {
  padding: 11px 13px;
  border-left: 3px solid #86b7fe;
  background: #f7faff;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.coupon-sales-item span {
  color: #667085;
  font-size: 10px;
}

.coupon-sales-item strong {
  color: #0d6efd;
  font-size: 18px;
  font-weight: 600;
}

.coupon-sales-item-vat {
  border-left-color: #f59e0b;
}

.coupon-sales-item-vat strong {
  color: #b54708;
}

.coupon-sales-item-net {
  border-left-color: #198754;
}

.coupon-sales-item-net strong {
  color: #198754;
}

@media (max-width: 767px) {
  .coupon-overview {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .coupon-metrics {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .coupon-metric {
    min-height: 82px;
    padding: 10px;
  }

  .coupon-metric strong {
    font-size: 20px;
  }

  .coupon-sales-metrics {
    grid-template-columns: 1fr;
  }
}

.coupon-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px;
  border: 1px solid #dbe7f7;
  background: #f7faff;
}

.coupon-search-type {
  width: 190px;
}

.coupon-search-input {
  flex: 1 1 260px;
  min-width: 180px;
}

.coupon-search-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 31px;
}

.coupon-search-submit {
  border-color: #b6d4fe;
  background: #eef4ff;
  color: #0d6efd;
}

.coupon-search-submit:hover:not(:disabled),
.coupon-search-submit:focus:not(:disabled) {
  border-color: #86b7fe;
  background: #dbeafe;
  color: #0a58ca;
}

.coupon-search-submit:disabled {
  border-color: #dbe7f7;
  background: #f5f8fc;
  color: #9dbce8;
}

.coupon-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.coupon-page-button,
.coupon-page-status {
  height: 26px;
  border: 1px solid #b6d4fe;
  border-radius: 4px;
  background: #eef4ff;
  color: #0d6efd;
}

.coupon-page-button {
  width: 26px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.coupon-page-button:hover:not(:disabled) {
  background: #dbeafe;
  border-color: #86b7fe;
}

.coupon-page-button:disabled {
  color: #9dbce8;
  background: #f5f8fc;
  border-color: #dbe7f7;
  cursor: not-allowed;
}

.coupon-page-status {
  min-width: 50px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
}

.export-mini-btn {
  width: 22px;
  height: 22px;
  border: 1px solid #d0d5dd;
  border-radius: 999px;
  background: #ffffff;
  color: #0d6efd;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.export-mini-btn:hover:not(:disabled) {
  border-color: #0d6efd;
  background: #eef4ff;
}

.export-mini-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: {},
      token: localStorage.getItem("jwt"),
      is_enable_coupon_system: null,
      conpon_obj: [],
      pending_coupon_orders: [],
      coupon_filter: 'all',
      coupon_amount_filter: 'all',
      coupon_page: 1,
      coupon_page_size: 40,
      show_coupon_vouchers: false,
      coupon_search_type: 'mobile',
      coupon_search_value: '',
      is_coupon_searching: false,
      coupon_sales_summary: {
        total_including_vat: 0,
        total_excluding_vat: 0,
        vat_amount: 0,
        total_after_payment_fee: 0,
      },

      coupon_discount_unit: null,
      coupon_type: "BOTH",
      coupon_discount_percent: null,
      coupon_discount_type: "PERCENTAGE",
      coupon_discount_prefix: "",
      page_permission: null,
      event_coupon_obj: {},
      systemFacebookName: process.env.VUE_APP_SYSTEM_FACEBOOK_NAME || 'Facebook',
      websiteUrl: process.env.VUE_APP_WEBSITE_URL,

    };
  },
  computed: {
    // systemFacebookName() {
    //   return process.env.VUE_APP_SYSTEM_FACEBOOK_NAME || 'Facebook';
    // },
    statusFilteredCoupons() {
      if (this.coupon_filter === 'pending_payment') {
        return this.pending_coupon_orders;
      }

      if (this.coupon_filter === 'used') {
        return this.conpon_obj.filter((item) => Number(item.unit) <= 0);
      }

      if (this.coupon_filter === 'unused') {
        return this.conpon_obj.filter((item) => Number(item.unit) >= 1);
      }

      return this.conpon_obj;
    },
    coupon_filter_counts() {
      return {
        all: this.conpon_obj.length,
        used: this.conpon_obj.filter((item) => Number(item.unit) <= 0).length,
        unused: this.conpon_obj.filter((item) => Number(item.unit) >= 1).length,
        pending_payment: this.pending_coupon_orders.length,
      };
    },
    coupon_amount_filter_options() {
      return [...new Set(this.statusFilteredCoupons.map((item) => Number(item.amount) || 0))]
        .sort((amountA, amountB) => amountA - amountB);
    },
    coupon_amount_filter_counts() {
      return this.statusFilteredCoupons.reduce((counts, item) => {
        const amount = Number(item.amount) || 0;
        counts[String(amount)] = (counts[String(amount)] || 0) + 1;
        return counts;
      }, {});
    },
    filteredCoupons() {
      if (this.coupon_amount_filter === 'all') {
        return this.statusFilteredCoupons;
      }

      return this.statusFilteredCoupons.filter((item) => (Number(item.amount) || 0) === this.coupon_amount_filter);
    },
    coupon_stats() {
      return {
        total: this.conpon_obj.length,
        used: this.conpon_obj.filter((item) => Number(item.unit) <= 0).length,
        remaining: this.conpon_obj.filter((item) => Number(item.unit) >= 1).length,
      };
    },
    coupon_amount_summary_map() {
      const buildSummary = (items) => {
        const summary = items.reduce((counts, item) => {
          const amount = Number(item.amount) || 0;
          counts[amount] = (counts[amount] || 0) + 1;
          return counts;
        }, {});

        return Object.keys(summary)
          .map((amount) => ({
            amount: Number(amount),
            count: summary[amount],
          }))
          .sort((itemA, itemB) => itemA.amount - itemB.amount);
      };

      return {
        total: buildSummary(this.conpon_obj),
        used: buildSummary(this.conpon_obj.filter((item) => Number(item.unit) <= 0)),
        remaining: buildSummary(this.conpon_obj.filter((item) => Number(item.unit) >= 1)),
      };
    },
    coupon_chart_series() {
      return [this.coupon_stats.used, this.coupon_stats.remaining];
    },
    coupon_chart_options() {
      return {
        chart: {
          type: 'donut',
          fontFamily: 'Kanit, sans-serif',
          foreColor: '#475467',
          toolbar: { show: false },
        },
        labels: ['ใช้งานแล้ว', 'คงเหลือ'],
        colors: ['#f59e0b', '#0d6efd'],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '10px',
            fontFamily: 'Kanit, sans-serif',
            fontWeight: 500,
          },
        },
        legend: {
          position: 'bottom',
          fontSize: '9px',
          fontFamily: 'Kanit, sans-serif',
        },
        stroke: {
          colors: ['#ffffff'],
          width: 2,
        },
        plotOptions: {
          pie: {
            donut: {
              size: '68%',
              labels: {
                show: true,
                name: {
                  fontSize: '11px',
                  fontFamily: 'Kanit, sans-serif',
                },
                value: {
                  fontSize: '11px',
                  fontFamily: 'Kanit, sans-serif',
                },
                total: {
                  show: true,
                  label: 'ทั้งหมด',
                  fontSize: '11px',
                  fontFamily: 'Kanit, sans-serif',
                  formatter: () => String(this.coupon_stats.total),
                },
              },
            },
          },
        },
        noData: {
          text: 'ไม่มีข้อมูล',
          style: {
            fontSize: '10px',
            fontFamily: 'Kanit, sans-serif',
          },
        },
      };
    },
    coupon_total_pages() {
      return Math.ceil(this.filteredCoupons.length / this.coupon_page_size);
    },
    paginatedCoupons() {
      const start = (this.coupon_page - 1) * this.coupon_page_size;
      return this.filteredCoupons.slice(start, start + this.coupon_page_size);
    },
    filteredVoucherCoupons() {
      return this.coupon_filter === 'used'
        ? []
        : this.conpon_obj.filter((item) => Number(item.unit) >= 1);
    },
  },
  watch: {
    coupon_filter() {
      this.coupon_amount_filter = 'all';
      this.coupon_page = 1;
    },
    coupon_amount_filter() {
      this.coupon_page = 1;
    },
  },
  async created(){
    this.token = localStorage.getItem("jwt")
  },
  async mounted() {
    try {
      this.user = JSON.parse(localStorage.getItem("user"));

      await this.checkpermision();
      if(this.page_permission === 'Y'){
        await this.getEventCoupon()
        this.get_coupon()
      }

    } catch (error) {
      alert("An error has occurred. Please contact the system administrator.");
    }
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value) || 0);
    },
    async exportToPDF() {
      try {
        // Show loading state
        const button = document.getElementById('export-pdf-btn');
        if (!button) {
          throw new Error('Export button not found');
        }
        const originalText = button.innerHTML;
        button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Generating PDF...';
        button.disabled = true;

        // Dynamically import required libraries
        const html2canvas = await import('html2canvas');
        const { jsPDF } = await import('jspdf');

        // Create a container for all vouchers
        const printContainer = document.createElement('div');
        printContainer.style.cssText = `
          position: absolute;
          top: -9999px;
          left: -9999px;
          width: 210mm;
          padding: 5mm;
          background: white;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;
          gap: 1mm;
        `;
        
        // Clone each voucher card for printing
        const activeCoupons = this.conpon_obj.filter(item => Number(item.unit) >= 1);
        activeCoupons.forEach((item, index) => {
          // Create voucher for each unit available
          for (let i = 0; i < item.unit; i++) {
            const voucherDiv = document.createElement('div');
            voucherDiv.style.cssText = `
              width: 48mm;
              height: 30mm;
              margin-bottom: 1mm;
              background: linear-gradient(145deg, #ff0000 00%, #ffffff 70%);
              border-radius: 0px;
              padding: 1mm;
              color: rgb(0, 0, 0);
              position: relative;
              box-sizing: border-box;
              page-break-inside: avoid;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            `;
            
            voucherDiv.innerHTML = `
              <div style="text-align: center; position: relative; flex: 1; display: flex; flex-direction: column; justify-content: center;">
                
                <div style="position: relative; z-index: 2;">
                  <div style="font-size: 12px; font-weight: bold; margin-bottom: 1mm;">${item.discount}% OFF</div>
                  <div style="font-size: 10px; opacity: 0.9; text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 2mm;">SPECIAL PROMO CODE</div>
                  <div style="background: rgba(255, 255, 255, 0.25); padding: 1mm 2.5mm; border-radius: 2mm; font-family: 'Courier New', monospace; font-size: 15px; font-weight: bold; border: 1px dashed rgba(255, 255, 255, 0.6); margin-bottom: 1mm;">${item.code}</div>
                </div>
              </div>
              <div style="text-align: center; font-size: 10px; opacity: 0.8; margin-top: 1mm;">
                Follow us Facebook: ${this.systemFacebookName}
              </div>
            `;
            printContainer.appendChild(voucherDiv);
          }
        });

        document.body.appendChild(printContainer);

        // Generate PDF
        const canvas = await html2canvas.default(printContainer, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff'
        });

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        });

        const imgData = canvas.toDataURL('image/png');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        
        // Calculate how much content fits on one page
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const ratio = canvasWidth / pdfWidth;
        const scaledCanvasHeight = canvasHeight / ratio;
        
        // If content is larger than one page, split it
        if (scaledCanvasHeight > pdfHeight) {
          let yPosition = 0;
          let pageCount = 0;
          
          while (yPosition < scaledCanvasHeight) {
            if (pageCount > 0) {
              pdf.addPage();
            }
            
            // Calculate the portion of canvas to add to current page
            const sourceY = yPosition * ratio;
            const sourceHeight = Math.min(pdfHeight * ratio, canvasHeight - sourceY);
            
            // Create a temporary canvas for this page portion
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvasWidth;
            tempCanvas.height = sourceHeight;
            const tempCtx = tempCanvas.getContext('2d');
            
            // Draw the portion of the original canvas
            tempCtx.drawImage(canvas, 0, sourceY, canvasWidth, sourceHeight, 0, 0, canvasWidth, sourceHeight);
            
            const tempImgData = tempCanvas.toDataURL('image/png');
            const tempHeight = sourceHeight / ratio;
            
            pdf.addImage(tempImgData, 'PNG', 0, 0, pdfWidth, tempHeight);
            
            yPosition += pdfHeight;
            pageCount++;
          }
        } else {
          // Content fits on one page
          pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, scaledCanvasHeight);
        }

        pdf.save('voucher-cards.pdf');

        // Clean up
        document.body.removeChild(printContainer);
        
        // Reset button
        button.innerHTML = originalText;
        button.disabled = false;

        alert('PDF exported successfully!');

      } catch (error) {
        console.error('Error exporting PDF:', error);
        alert('Error exporting PDF. Please try again.');
        
        // Reset button on error
        const button = document.getElementById('export-pdf-btn');
        if (button) {
          button.textContent = 'Export PDF for Print';
          button.disabled = false;
        }
      }
    },
    escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    getExportTimestamp() {
      const now = new Date();
      const pad = (value) => String(value).padStart(2, '0');

      return [
        now.getFullYear(),
        pad(now.getMonth() + 1),
        pad(now.getDate()),
        pad(now.getHours()),
        pad(now.getMinutes()),
      ].join('');
    },
    async exportToExcel(filterType = 'all') {
      const XLSX = await import('xlsx');

      let sourceCoupons = this.conpon_obj;
      if (filterType === 'used') {
        sourceCoupons = this.conpon_obj.filter((item) => Number(item.unit) <= 0);
      } else if (filterType === 'unused') {
        sourceCoupons = this.conpon_obj.filter((item) => Number(item.unit) >= 1);
      }

      if (sourceCoupons.length === 0) {
        return;
      }

      const rows = sourceCoupons.map((item, index) => ({
        'No.': index + 1,
        Code: item.code,
        Description: item.description,
        Amount: Number(item.amount) || 0,
        'Paid Amount': Number(item.paid_amount) || 0,
        Discount: item.discount,
        Unit: item.unit,
        Status: Number(item.unit) >= 1 ? 'Unused' : 'Used',
        'Create Date': item.create_date,
        'Order UUID': item.order_uuid,
        'Order Link': item.order_uuid ? `${this.websiteUrl}/coupon/${item.order_uuid}` : '',
        Name: item.name,
        Mobile: item.mobile,
        Email: item.email,
        'Payment Ref': item.payment_ref,
        'Payment Date': item.payment_date,
        'Photo Order UUID': item.order_image_uuid,
        'Photo Order Link': item.order_image_uuid ? `${this.websiteUrl}/d/${item.order_image_uuid}` : '',
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      for (let rowIndex = 2; rowIndex <= sourceCoupons.length + 1; rowIndex++) {
        const amountCell = worksheet[`D${rowIndex}`];
        if (amountCell) {
          amountCell.t = 'n';
          amountCell.z = '0.0';
        }

        const paidAmountCell = worksheet[`E${rowIndex}`];
        if (paidAmountCell) {
          paidAmountCell.t = 'n';
          paidAmountCell.z = '0.0';
        }
      }

      worksheet['!cols'] = [
        { wch: 8 },
        { wch: 22 },
        { wch: 26 },
        { wch: 14 },
        { wch: 14 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
        { wch: 18 },
        { wch: 38 },
        { wch: 48 },
        { wch: 24 },
        { wch: 18 },
        { wch: 28 },
        { wch: 20 },
        { wch: 18 },
        { wch: 38 },
        { wch: 48 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Coupons');
      XLSX.writeFile(workbook, `coupon-export-${this.$route.params.q}-${filterType}-${this.getExportTimestamp()}.xlsx`);
    },
    async clear(){
      this.get_coupon()
    },
    async refreshCoupons() {
      await this.get_coupon(this.coupon_search_value.length >= 4);
    },
    async searchCoupons() {
      if (this.coupon_search_value.length < 4) {
        alert('กรุณากรอกคำค้นหาอย่างน้อย 4 ตัวอักษร');
        return;
      }

      await this.get_coupon(true);
    },
    async clearCouponSearch() {
      this.coupon_search_value = '';
      await this.get_coupon();
    },
    async generate_coupon(){
      let data = {
        coupon_type: this.coupon_type,
        coupon_discount_unit: this.coupon_discount_unit,
        coupon_discount_percent: this.coupon_discount_percent,
        coupon_discount_type: this.coupon_discount_type,
        coupon_discount_prefix: this.coupon_discount_prefix,
        event_key: this.$route.params.q,
      };
      
      const headers = { 
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/generate-coupon",data, { headers } );
      if (response.data.status === "success") {
          alert(response.data.message)
          this.get_coupon()
      } else {
        alert(response.data.message || "Error pls contact admin!");
      }
    }, 
    async update_event_coupon(){
      let data = {
        event_key: this.$route.params.q,
        is_enable_coupon_system: this.is_enable_coupon_system
      };
      
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/event-coupon",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        
      } else {
        alert("An error has occurred. Please contact the system administrator.");
      }
    }, 
    async getEventCoupon(){
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/event",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.event_coupon_obj = response.data.body
        this.is_enable_coupon_system = this.event_coupon_obj[0].is_coupon
      } else {
        alert("An error has occurred. Please contact the system administrator.");
      }
    },  
    async checkpermision(){
      try {
        let data = {
          event_key: this.$route.params.q,
        };
        const headers = {
          'Authorization': 'Bearer ' + this.token
        };
        const response = await axios.post("/v1/partner/permission", data,{
          headers
        });
        if (response.data.status === "success") {
          let bodyPermission = JSON.parse(JSON.stringify(response.data.body));
          this.page_permission = bodyPermission.permission

          this.user = JSON.parse(localStorage.getItem('user'))

        if(this.page_permission ==='Y'){
            ///

        }

        }else{
          alert("permission is not recognized by admin")
        }
        } catch (error) {
        alert("login An error has occurred. Please contact the system administrator.")
        //this.$router.push({ path: "/auth/login" });
      }
    },  
    async get_coupon(useSearch = false){

      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      let data = {
        event_key: this.$route.params.q,
      };

      if (useSearch) {
        data.search_type = this.coupon_search_type;
        data.search_value = this.coupon_search_value;
      }

      this.is_coupon_searching = true;
      try {
        const response = await axios.post(
          "v1/utils/coupons",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          this.conpon_obj = response.data.body
          this.pending_coupon_orders = response.data.pending_orders || []
          this.coupon_sales_summary = response.data.sales_summary || {
            total_including_vat: 0,
            total_excluding_vat: 0,
            vat_amount: 0,
            total_after_payment_fee: 0,
          }
          this.coupon_amount_filter = 'all'
          this.coupon_page = 1
        } else {
          alert(response.data.message || "An error has occurred. Please contact the system administrator.");
        }
      } finally {
        this.is_coupon_searching = false;
      }
    },
  },
};
</script>
